import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fallback", "originName"];
import { useEffect } from 'react';
export default function useDeprecated(_ref) {
  let {
      fallback,
      originName
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const name = Object.keys(rest)[0];
  const value = rest[name];
  const isNull = value == null;
  useEffect(() => {
    if (isNull) return;
    console.warn("Tangram: `".concat(name, "` ").concat(originName ? "from `".concat(originName, "` ") : '', "is deprecated.").concat(fallback ? " ".concat(fallback, ".") : ''));
  }, [name, originName, isNull, fallback]);
}